import { render } from "./ordersBdp.vue?vue&type=template&id=41f2a816&scoped=true"
import script from "./ordersBdp.vue?vue&type=script&lang=js"
export * from "./ordersBdp.vue?vue&type=script&lang=js"

import "./ordersBdp.vue?vue&type=style&index=0&id=41f2a816&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-41f2a816"

export default script